/**
 * SlideBackgroundLayer — per-slide background that sits on top of the
 * deck-level background and below the slide content. Renders the
 * per-slide radial gradient + the per-slide `effectAmbient` particle
 * field.
 *
 * Compose order (back → front):
 *   1. DeckBackgroundLayer (deck-level particles)
 *   2. SlideBackgroundLayer (per-slide particles + colour wash)
 *   3. SlideContentLayer (visible content)
 *   4. CinematicOverlaysLayer (vignette, grain, light-leak, intro FX)
 *
 * Z-index range: 2..3
 *   - .preview-slide-bg  → 2
 *   - ParticleOverlay wrapper → 3 (already enforced inside ParticleOverlay)
 */
import { ParticleOverlay } from '../particles/ParticleOverlay';
import type { PreviewSlideData } from '../PreviewSlide';

export function SlideBackgroundLayer({ slide }: { slide: PreviewSlideData }) {
  return (
    <>
      <div className="preview-slide-bg" />
      <ParticleOverlay
        code={slide.effectAmbient || 'none'}
        intensity={slide.effectIntensity ?? 0.5}
      />
    </>
  );
}
